import { Component, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, interval } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { TableBtn } from 'src/app/shared/interfaces/table-btn';
import { TableColumn } from 'src/app/shared/interfaces/table-column';
import { AuthenticationService } from 'src/app/_services';
import { SelectionModel } from '@angular/cdk/collections';
import * as _moment from 'moment';
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';

//import {images} from '..//..//..//..//assets/images/connector/1'
@Component({
  selector: 'telio-general-table',
  templateUrl: './general-table.component.html',
  styleUrls: ['./general-table.component.scss']
})
export class GeneralTableComponent implements OnChanges, OnDestroy, OnInit {

  @Input() columns: TableColumn[] = [];
  @Input() buttons: TableBtn[] = [];
  @Input() data: any[] = [];
  @Input() filter: boolean = false;
  @Input() filterPlaceholder: string = 'Filter';
  @Input() footer: string = null;
  @Input() pagination: number[] = [];
  @Input() pageSize: number;
  @Input() tableMinWidth: number = 550;
  @Input() tableMinHeight: number = 48;
  @Output() filteredData = new EventEmitter<any>();
  @Output() buttonClick = new EventEmitter<string[]>();
  @Input() actionHeader: string = null;
  @Input() actionReload = false;
  @Output() actionClick = new EventEmitter();
  @Output() actionCSV = new EventEmitter();
  @Input() actionCSVFlag = false;
  reloadLabel: string = '';
  downloadCSVLabel: string = '';
  @Input() actionFeatureLabel: string = '';
  @Input() actionFeatureFlag = false;
  @Output() actionFeature = new EventEmitter();
  @Input() resizeColumn = false;

  dataSource: MatTableDataSource<any>;
  displayedColumns: string[];
  rs;
  dateTimePlaceHolder = 'Date Filter';

  @Input() currentPage: number;
  @Output() loadData = new EventEmitter<any>();
  @Input() totalDataCount: any;
  @Output() sortClick = new EventEmitter<any>();
  @Output() linkClick = new EventEmitter<any>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  form = new UntypedFormGroup({
    searchFilter: new UntypedFormControl(''),
  })
  selectForm = new UntypedFormGroup({
    select: new UntypedFormControl('All')
  })
  obs: Subscription;
  @Input() enableCheckbox = false;
  @Input() selection = new SelectionModel<MatTableDataSource<any>>(true, []);
  checkboxClkfixDftlClmn = true;
  @Output() checkboxRow = new EventEmitter<any>();
  @Output() selectionChange = new EventEmitter<any>();
  @Input() selectFeatureList = [];
  @Input() selectFeature = false;
  @Input() selectDefaultValue = 'All';
  startDate: Date;
  endDate: Date;
  @Output() reportFilteredValue = new EventEmitter<any>();
  @Input() dataPickerFeature = false;
  @Input() devicedataReload = false;
  @Input() showCustomFooter: boolean = false;
  @Input() statusList: { name: string, color: string }[] = [];

  constructor(readonly translate: TranslateService,
    private authenticationService: AuthenticationService) {
    this.reloadLabel = 'generalTable.reload';
    this.downloadCSVLabel = 'generalTable.downloadCSV';

    this.translate.onLangChange.subscribe(() => {
      this.translateLabels();
    });
    let localInfo = this.authenticationService.getlocalInfo.subscribe(local => {
      this.rs = local ? local.currency_symbol : this.translate.instant('rs');
      this.rs = '(' + this.rs + ')'
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data) {
      if (changes.data) {
        this.refreshData();

        this.displayedColumns = [...this.columns.map(c => c.columnDef)];
        let buttonActionEnable = this.buttons.find(res => res.enable == true);
        if (this.buttons.length > 0 && buttonActionEnable)  this.displayedColumns = [...this.displayedColumns, 'actions'];
      }
      this.translateLabels();
    }

    if (this.enableCheckbox && this.checkboxClkfixDftlClmn) {
      this.displayedColumns = ['select'].concat(this.displayedColumns);
    }
  }

  ngOnInit() {
    this.selectForm.get('select').setValue(this.selectDefaultValue);
    this.refreshData();
    this.obs = this.form.valueChanges
      .pipe(debounce(() => interval(1000)))
      .subscribe(data => this.applyFilter(data.searchFilter));

    // const defaultStartDate = moment().subtract(1, 'month').set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    // const defaultEndDate = moment().set({ hour: 23, minute: 59, second: 59, millisecond: 999 });
    // this.startDate = defaultStartDate.toDate();
    // this.endDate = defaultEndDate.toDate();
  }

  refreshData() {
    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    setTimeout(() => {
      if (this.paginator) {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = this.totalDataCount;
      }
    })
  }

  translateLabels() {
    this.dataSource.paginator = this.paginator;
    this.paginator._intl.itemsPerPageLabel = this.translate.instant('generalTable.perPage');
    this.paginator._intl.nextPageLabel = this.translate.instant('generalTable.nextPage');
    this.paginator._intl.previousPageLabel = this.translate.instant('generalTable.previousPage');
    this.paginator._intl.firstPageLabel = this.translate.instant('generalTable.firstPage');
    this.paginator._intl.lastPageLabel = this.translate.instant('generalTable.lastPage');
  }

  applyFilter(filterValue: string) {
    this.filterPortion(filterValue);
  }

  filterPortion(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.filteredData.emit(filterValue);
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

    this.dataSource.sort = this.sort;
    if (this.dataSource.filteredData.length == 0) {
      this.totalDataCount = 0;
    }
  }

  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    const pagination = {
      currentPage: this.pageSize * event.pageIndex,
      pageSize: this.pageSize
    }
    this.loadData.emit(pagination);
    this.resetScrollbarToTop();
  }

  typeOf(value) {
    return typeof value;
  }

  resetScrollbarToTop() {
    const table = document.getElementById("matGeneralTable");
    if (table) {
      const tableBody = (<HTMLTableElement>table).tBodies;
      if (tableBody && tableBody.length > 0) {
        tableBody[0].scrollTop = 0;
      }
    }
  }

  sortData(event) {
    this.sortClick.emit(event);
  }

  link(column, row) {
    let data = {
      column: column,
      row: row
    }
    this.linkClick.emit(data);
  }

  isCellString(cell: any): boolean {
    return typeof cell === 'string';
  }

  isCellArray(cell: any): boolean {
    if (Array.isArray(cell)) {
      return true;
    }
    if (typeof cell === 'string') {
      return cell.split(',').every(url => url.trim() !== '');
    }
    return false;
  }

  getParsedCell(cell: any): any[] {
    if (typeof cell === 'string') {
      return cell.split(',').map(url => url.trim()).filter(url => url !== '');
    }
    return Array.isArray(cell) ? cell : [];
  }

  getTooltipText(url: string): string {
    const parts = url.split('/connector/')[1]?.split('.png')[0];
    if (parts) {
      const decodedParts = decodeURIComponent(parts);
      const [portType, status] = decodedParts.split('-');
      const capitalizedStatus = status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
      return `${portType.trim()}: ${capitalizedStatus.trim()}`;
    }
    return 'Other';
  }

  reload() {
    this.dateTimePlaceHolder = 'Date Filter';
    setTimeout(() => {
      const inputElement = document.querySelector('input[ngxDaterangepickerMd]') as HTMLInputElement;
      if (inputElement) {
        inputElement.value = this.dateTimePlaceHolder;
      }
    }, 0);
    const currentFilterValue = this.form.get('searchFilter').value;
    if (currentFilterValue) {
      this.form.get('searchFilter').setValue('');
    } else {
      this.actionClick.emit();
    }
  }


  getDataCheck(data: any) {
    return (this.dataSource.filteredData.length === 0 && data != '')
  }

  getStatusColor(status: any) {
    status = status.toLowerCase() || '';
    switch (true) {
      case (status == 'active') || (status == 'activated') || (status == 'available'):
        return 'green';
      case (status == 'inactive') || (status == 'unavailable'):
        return 'gray';
      case (status == 'faulted') || (status == 'blocked') || (status == 'failed'):
        return 'red';
      case (status == 'pending for activated') || (status == 'pending for activation') || (status == 'suspended_ev') || (status == 'pending'):
        return 'orange';
      case (status == 'new'):
        return 'purple';
      case (status == 'preparing'):
        return '#e5e500';
      case (status == 'charging'):
        return '#355E3B';
      case (status == 'suspendedevse'):
        return '#008080';
      case (status == 'finishing'):
        return '#722f37';
      case (status == 'reserved'):
        return 'palevioletred';
        case (status == 'rejected'):
          return '#000080';
      case (status == 'others'):
        return 'skyblue';
      default:
        return '';
    }
  }

  selectOrClear() {
    this.isCheckboxSelected() ? this.selection.clear() : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  isCheckboxSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    this.onSelectedRow(this.selection.selected);
    return numSelected == numRows;
  }

  checkboxLabel(row?: any): string {
    return !row ? `${this.isCheckboxSelected() ? 'deselect' : 'select'} all` :
      `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.dataIndex + 1}`;
  }

  onSelectedRow(row: any) {
    this.checkboxClkfixDftlClmn = false;
    this.checkboxRow.emit(row);
  }

  selectChange(value: any) {
    this.selectionChange.emit(value);
  }

  ngOnDestroy() {
    this.form.reset();
    this.obs && this.obs.unsubscribe();
  }

  filterReport() {
    let filterData = {
      startDate: this.startDate,
      endDate: this.endDate,
    };
    this.reportFilteredValue.emit(filterData);
  }

  change(event) {
    if (event && event.startDate && event.endDate) {
      this.startDate = event.startDate.$d;
      this.endDate = event.endDate.$d;
      this.dateTimePlaceHolder = this.getPlaceholder();
      setTimeout(() => {
        const inputElement = document.querySelector('input[ngxDaterangepickerMd]') as HTMLInputElement;
        if (inputElement) {
          inputElement.value = this.dateTimePlaceHolder;
        }
      }, 0);
    } else {
      this.dateTimePlaceHolder = 'Date Filter';
    }
  }


  // getPlaceholder(): string {
  //   const startDateFormatted = moment(this.startDate).format('MMM D, YYYY h:mm A');
  //   const endDateFormatted = moment(this.endDate).format('MMM D, YYYY h:mm A');
  //   return `${startDateFormatted} - ${endDateFormatted}`;
  // }

  getPlaceholder(): string {
    if (!this.startDate || !this.endDate) {
      return 'Date Filter';
    }
    // else if (this.devicedataReload) {
    //   return 'Date Filter';
    // }
    else {
      const startDateFormatted = moment.utc(this.startDate).format('MMM D, YYYY h:mm A');
      const endDateFormatted = moment.utc(this.endDate).format('MMM D, YYYY h:mm A');
      return `${startDateFormatted} - ${endDateFormatted}`;
    }
  }


}

